export default __webpack_public_path__ + "static/media/sohidul.cf7708b2.jpg";